import * as msal from "@azure/msal-browser";
import { JSLog } from "@zg-reportsus/zg-reportsus-common-js";

const isIE = navigator?.userAgent?.includes("Trident/") || navigator?.userAgent?.includes("MSIE")

let signInType;

// Config object to be passed to Msal on creation
export const msalConfig = {
    auth: {
        clientId: window.phaAppSettings.AppId,
        authority: window.phaAppSettings.EntraUrl ?? "https://login.microsoftonline.com/common",
        redirectUri: `https://${window.location.host}/EWT/v1/landing`, // This is the landing page to redirect to after M365 auth
        navigateToLoginRequestUrl: false, // This prevents MSAL from redirecting to the login page after auth
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        allowPlatformBroker: false, // Disables WAM Broker
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case msal.LogLevel.Error:
                        console.error(message);
                        return;
                    case msal.LogLevel.Info:
                        console.info(message);
                        return;
                    case msal.LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case msal.LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

// Create the main MSAL instance
export const MSAL = new msal.PublicClientApplication(msalConfig);

export async function handleAuthResponse(response) {
    try {
        if (response !== null) {
            MSAL.setActiveAccount(response.account);
            window.m365AuthData.Reporter = response.account.username;
            window.m365AuthData.M365AuthFailed = false;
        } else {
            JSLog.error("No response from MSAL redirect handling.");
            window.m365AuthData.M365AuthFailed = true;
        }
    } catch (error) {
        console.error("Error handling MSAL auth response:", error);
        window.m365AuthData.M365AuthFailed = true;
    }
}

// no longer used here, but kept for adding back popup auth alongside redirect
async function signIn(method) {
    signInType = isIE ? "redirect" : method;
    if (signInType === "popup") {
        return MSAL.loginPopup(loginRequest).then(handleAuthResponse).catch(function (error) {
            console.log(error);
        });
    } else if (signInType === "redirect") {
        return MSAL.loginRedirect(loginRequest)
    }
}

// I don't expect to be logging out, but if we ever do, this is how
function signOut(interactionType) {
    const logoutRequest = {
        account: MSAL.getActiveAccount()
    };

    if (interactionType === "popup") {
        MSAL.logoutPopup(logoutRequest).then(() => {
            window.location.reload();
        });
    } else {
        MSAL.logoutRedirect(logoutRequest);
    }
}

// This popup workflow is used for getting an access token for Identity operations
export async function getTokenPopup(request) {
    return await MSAL.acquireTokenSilent(request).catch(async (error) => {
        console.log("silent token acquisition fails.");
        if (error instanceof msal.InteractionRequiredAuthError) {
            console.log("acquiring token using popup");
            return MSAL.acquireTokenPopup(request).catch(error => {
                console.error(error);
            });
        } else {
            console.error(error);
        }
    });
}

// This redirect workflow is used for getting an access token for Identity operations
export async function getTokenRedirect(request) {
    return await MSAL.acquireTokenSilent(request).catch(async (error) => {
        console.log("silent token acquisition fails.");
        if (error instanceof msal.InteractionRequiredAuthError) {
            // fallback to interaction when silent call fails
            console.log("acquiring token using redirect");
            MSAL.acquireTokenRedirect(request);
        } else {
            console.error(error);
        }
    });
}

// Gets an access token for Graph Mail API operations (see scopes)
export async function getAccessToken() {
    return await MSAL.acquireTokenSilent(graphRequest).catch(async (error) => {
        console.log("silent token acquisition fails.");
        if (error instanceof msal.InteractionRequiredAuthError) {
            console.log("acquiring token using popup");
            return MSAL.acquireTokenPopup(graphRequest).catch(error => {
                console.error(error);
            });
        } else {
            console.error(error);
        }
    });
}

export const loginRequest = {
    scopes: ["User.Read"],
    state: window.phaAppSettings.EncryptedState // This is the encrypted EWT hash to rewrite the path to after M365 auth
};

export const graphRequest = {
    scopes: ["Mail.Read", "Mail.ReadWrite", "Mail.Send"]
};